export const DEFAULT_INSTRUCTION_PAGINATION = {
  itemsPerPage: 9,
  page: 1,
};